<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="SysDictFilter" :model="SysDict" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="名称" prop="formFilter.name">
          <el-input class="filter-item" v-model="SysDict.formFilter.name"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="编码" prop="formFilter.code">
          <el-input class="filter-item" v-model="SysDict.formFilter.code"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="内容" prop="formFilter.content">
          <el-input class="filter-item" v-model="SysDict.formFilter.content"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetSysDict">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshSysDict(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="SysDict" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="18" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>系统字典列表</span>
              <div class="base-card-operation">
                <el-button @click="onAddSysDictClick()" type="text" :size="defaultFormItemSize"
                  :disabled="!checkPermCodeExist('SysDict:SysDict:AddSysDict') || !addSysDictEnabled">
                  添加
                </el-button>
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="sysDict" :data="SysDict.SysDict.impl.dataList" :size="defaultFormItemSize" @sort-change="SysDict.SysDict.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="SysDict.SysDict.impl.currentRowChange"
                  @row-click="handleRowClick" row-key="id" height="600px"
                >
                  <el-table-column type="selection" width="55px"></el-table-column>
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="SysDict.SysDict.impl.getTableIndex" />
                  <el-table-column label="名称" prop="name" width="200px">
                  </el-table-column>
                  <el-table-column label="类型" prop="typeDictMap.name" width="50px">
                  </el-table-column>
                  <el-table-column label="编码" prop="code" width="200px">
                  </el-table-column>
                  <el-table-column label="内容" prop="content" width="200px">
                  </el-table-column>
                  <el-table-column label="备注" prop="remark">
                  </el-table-column>
                  <el-table-column label="启用" prop="enableFlagDictMap.name">
                  </el-table-column>
                  <el-table-column label="图标" prop="icon">
                  </el-table-column>
                  <el-table-column label="排序" prop="sort">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right" width="90px">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                        :disabled="!checkPermCodeExist('SysDict:SysDict:delete')">
                        删除
                      </el-button>
                      <el-button @click.stop="onAddSysDictClick(scope.row)" type="text" :size="defaultFormItemSize" v-show="scope.row.type==='group'"
                                 :disabled="!checkPermCodeExist('SysDict:SysDict:AddSysDict') || !addSysDictEnabled">
                        添加
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="6" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>修改字典</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col :span="24">
                <EditSysDict ref="editSysDict"
                  v-if="checkPermCodeExist('EditSysDict')"
                  :id="(SysDict.SysDict.impl.currentRow || {}).id"
                  @submit="onEditSysDictSubmit"
                />
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import {findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { DictionaryController, SysDictController } from '@/api';
import addSysDict from '@/views/SysDict/addSysDict.vue';
import EditSysDict from '@/views/SysDict/editSysDict.vue';

export default {
  name: 'SysDict',
  props: {
    name: {
      default: undefined
    },
    content: {
      default: undefined
    },
    code: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    EditSysDict
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      selectedRow: {},
      formData: {
        SysDict: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          name: undefined,
          content: undefined,
          enableFlag: undefined,
          remark: undefined,
          sort: undefined,
          icon: undefined,
          gcode: undefined,
          tid: undefined,
          isDatasourceInit: false
        }
      },
      SysDict: {
        formFilter: {
          name: this.name,
          code: this.code,
          content: this.content
        },
        formFilterCopy: {
          name: this.name,
          code: this.code,
          content: this.content
        },
        SysDict: {
          impl: new TableWidget(this.loadSysDictWidgetData, this.loadSysDictVerify, false, true, 'sort', 1)
        },
        SysDictDiv: {
          isInit: false
        },
        EditSysDictDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
        this.$refs.sysDict.clearSelection();
      }
      this.$refs.sysDict.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetSysDict () {
      this.$refs.SysDictFilter.resetFields();
      this.refreshSysDict(true);
    },
    /**
     * 系统字典数据获取函数，返回Promise
     */
    loadSysDictWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        sysDictDtoFilter: {
          code: this.SysDict.formFilterCopy.code,
          name: this.SysDict.formFilterCopy.name,
          content: this.SysDict.formFilterCopy.content,
          searchString: this.name
        }
      }
      return new Promise((resolve, reject) => {
        SysDictController.list(this, params).then(res => {
          resolve({
            dataList: treeDataTranslate(res.data.dataList, 'id', 'pid'),
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.SysDict.SysDict.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.SysDict.SysDict.impl.currentRow.id, 'id');
              this.$refs.sysDict.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 系统字典数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysDictVerify () {
      this.SysDict.formFilterCopy.code = this.SysDict.formFilter.code;
      this.SysDict.formFilterCopy.name = this.SysDict.formFilter.name;
      this.SysDict.formFilterCopy.content = this.SysDict.formFilter.content;
      return true;
    },
    /**
     * 自定义组件编辑字典提交方法
     */
    onEditSysDictSubmit (code) {
      if (code) {
        // 自定义组件提交后刷新当前fragment，如果不需要刷新数据，请在这里修改这里
        this.refreshSysDict();
      }
    },
    /**
     * 更新系统字典列表
     */
    refreshSysDictDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.SysDict.SysDict.impl.refreshTable(true, 1);
      } else {
        this.SysDict.SysDict.impl.refreshTable();
      }
      this.SysDict.SysDictDiv.isInit = true;
    },
    /**
     * 更新系统字典
     */
    refreshSysDict (reloadData = false) {
      if (reloadData) this.$refs.editSysDict.onResume();
      if (reloadData) {
        this.SysDict.SysDict.impl.refreshTable(true, 1);
      } else {
        this.SysDict.SysDict.impl.refreshTable();
      }
      if (!this.SysDict.isInit) {
        // 初始化下拉数据
      }
      this.SysDict.isInit = true;
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      if (row.pid === -1) {
        this.$message.error('删除失败!根节点不能删除!');
        return;
      }
      if (row.type === 'group') {
        this.$message.error('删除失败!系统组不能删除!');
        return;
      }
      if (row.children !== undefined && row.children.length > 0) {
        this.$message.error('删除失败!请先删除子项!');
        return;
      }
      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        SysDictController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.SysDict.SysDict.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 添加
     */
    onAddSysDictClick (row) {
      row = (row || this.SysDict.SysDict.impl.currentRow || {});
      if (row.type !== 'group') {
        this.$message.error('添加失败!不能添加子节点!');
        return;
      }
      let type = (row.pid === -1) ? 'group' : 'kv';
      let params = {
        pid: row.id,
        gcode: row.code,
        type: type
      };
      let title = '添加';
      if (params.type === 'group') {
        title = '添加组';
      }
      this.$dialog.show(title, addSysDict, {
        area: '400px'
      }, params).then(res => {
        this.refreshSysDictDivWidget();
      }).catch(e => {});
    },
    onResume () {
      this.refreshSysDict(true);
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SysDict: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          name: undefined,
          content: undefined,
          enableFlag: undefined,
          remark: undefined,
          sort: undefined,
          icon: undefined,
          gcode: undefined,
          tid: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshSysDict();
    }
  },
  computed: {
    addSysDictEnabled () {
      return this.SysDict.SysDict.impl.currentRow != null;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
    // 系统字典选择行数据变化
    'SysDict.SysDict.impl.currentRow': {
      handler (newValue) {
      },
      immediate: true
    }
  }
}
</script>
